module.exports = __webpack_public_path__ + "img/CardBackground.07821f9c.jpg";